import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';

export class MakePaymentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { renderModal, showModal } = this.state;
        console.log("component state:", this.state);
        console.log("component props:", this.props);
        return (
            <>
                <div onClick={() => this.setState({
                    showModal: true,
                    renderModal: true
                })} className="" href="javascript:void(220221)">
                    <a href="javascript:void(220221)" class="btn btn-block btn-lg btn-danger btn-pay text-white">MAKE PAYMENT</a>
                </div>
                {renderModal &&
                    <MakePaymentModalComponent
                        accountNumber={this.props.accountNumber}
                        amount={this.props.amount}
                        pifPrice={ this.props.pifPrice}
                        pifBalance={this.props.pifBalance}
                        hasPaid={this.props.hasPaid}
                        pifSavings={this.props.pifSavings}
                        descriptionTitle={this.props.descriptionTitle}
                        description={this.props.description}
                        showModal={showModal}
                        handleClose={() => {
                            this.setState({ showModal: false });
                        }}
                        onExited={() => {
                            this.setState({ renderModal: false });
                        }} />}
            </>
        );
    }
}


class MakePaymentModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Amount: props.amount || '',
            Name: '', // Name will be shown but not editable
            AccountNumber: props.accountNumber,
            PifPrice: props.pifPrice,
            PifBalance: props.pifBalance,
            hasPaid: props.hasPaid,
            pifSavings: props.pifSavings
        };
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    save = (e) => {
        this.setState({
            isSaving: true,
            errors: null
        },
            () => {
                const payload = {
                    Amount: this.state.Amount,
                    DescriptionTitle: this.props.descriptionTitle,
                    Description: this.props.description
                };

                fetch(`/api/talent/${this.state.AccountNumber}/makepayment`,
                    {
                        method: "POST",
                        body: JSON.stringify(payload),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(req => req.json())
                    .then(resp => {
                        if (resp.redirectUrl) {
                            window.location.href = resp.redirectUrl;
                        } else {
                            this.setState({
                                errors: ["Payment could not be processed. Please try again later or contact Customer Care."],
                                isSaving: false
                            });
                        }
                    })
                    .catch(error => {
                        this.setState({
                            errors: ["An error occurred when trying to submit a payment. Please try again later or contact Customer Care."],
                            isSaving: false
                        });
                    });
            });
    }

    render() {
        const { showModal, handleClose, onExited } = this.props;
        return (
            <Modal isOpen={showModal} onClosed={onExited}>
                <ModalHeader toggle={handleClose}>
                    Make a Payment
                </ModalHeader>
                <ModalBody>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label>Amount</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">$</div>
                                </div>
                                <input 
                                    type="number" 
                                    name="Amount" 
                                    value={this.state.Amount} 
                                    onChange={this.handleInputChange}
                                    placeholder="Enter payment amount" 
                                    className="form-control" 
                                    step="0.01"
                                    min="0"
                                    disabled={this.state.isSaving}
                                />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.state.isSaving && <div className="float-left">
                        Processing...
                    </div>}
                    {this.state.errors && <div className="float-left text-left">
                        {this.state.errors.map(e => <div key={e}>{e}</div>)}
                    </div>}
          
                    {!this.state.errors && !this.state.isSaving &&
                    <a href="https://stripe.com" className="mr-auto" target="_blank" rel="noopener noreferrer">
                        <img src="/Powered_by_Stripe.svg" style={{ height: '30px' }} alt="Stripe Seal" />
                    </a>}
                    <Button onClick={this.save} disabled={this.state.isSaving}>
                        Make a Payment
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
